export default {
  flow: {
    scenarioFlowNoMPs: 'O Fluxograma do cenário não tem nenhuma Matéria Prima selecionada para as suas etapas.',
    scenarioFlowMPsNotInLCS: 'O Fluxograma do cenário não tem nenhuma Matéria Prima com LCS que intersecte.'
  }
}
